export default "__VITE_ASSET__bb67155c__"